import React from 'react';

const PricingTwoCardGrid = ({ free, paid }) => (
    <section className="lp-pricing-sec" style={{ paddingTop: 0, paddingBottom: 60, background: 'transparent' }}>
        <div className="lp-pricing-two-grid">
            <div className="lp-price" data-lp-reveal>
                <div className="lbl">{free.label}</div>
                <div className="amt">{free.amount}</div>
                <div className="sub">{free.sub}</div>
                <p style={{ flex: 1 }}>{free.text}</p>
                <a className="w100 lp-price-btn lp-price-btn--dark" href={free.cta.href}>{free.cta.text}</a>
            </div>
            <div className="lp-price lp-price--pro" data-lp-reveal data-lp-delay="100">
                <div className="lp-price-badge lp-price-badge--top-right">{paid.badge}</div>
                <div className="lbl" style={{ color: '#fff' }}>{paid.label}</div>
                <div className="amt white">{paid.amount}</div>
                <div className="sub">{paid.sub}</div>
                <p style={{ flex: 1 }}>{paid.text}</p>
                <a className="w100 lp-price-btn lp-price-btn--white" href={paid.cta.href}>{paid.cta.text}</a>
            </div>
        </div>
    </section>
);

export default PricingTwoCardGrid;
